import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import userServiceV1 from '../services/user.service';
import userServiceV3 from '../services/v3/user.service';
import { UseInfiniteGetUsersProps } from '../../../../utils/types/types';

export type SortDirection = 'asc' | 'desc';
export type SortBy = 'name' | 'email'; //update

export const useInfiniteGetUsers = ({
  searchTerm = '',
  roleIds,
  isInactive,
  pageSize = 10,
  sortBy = 'name',
  sortDirection = 'asc',
}: UseInfiniteGetUsersProps) => {
  return useInfiniteQuery({
    queryKey: [
      'users',
      { searchTerm, roleIds, isInactive, pageSize, sortBy, sortDirection },
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await userServiceV3.fetchUsers(
        searchTerm,
        roleIds,
        isInactive,
        pageParam,
        pageSize,
        sortBy,
        sortDirection
      );
      return {
        ...response,
        nextPage: pageParam + 1,
      };
    },
    getNextPageParam: (lastPage) =>
      lastPage.hasMore ? lastPage.nextPage : undefined,
    initialPageParam: 1,
  });
};

export const useGetUserById = (id: string) => {
  return useQuery({
    queryKey: ['user', id],
    queryFn: () => userServiceV3.fetchUserById(id),
    enabled: !!id,
  });
};

export const useGetRoles = () => {
  return useQuery({
    queryKey: ['roles'],
    queryFn: () => userServiceV1.fetchRoles(),
  });
};
